export default "__VITE_ASSET__Mh_VWnn9__"